(function () {
    'use strict';

    angular
        .module('app')
        .controller('CampaignsAddController', CampaignsAddController);

    CampaignsAddController.$inject = ['debug', '$stateParams', 'API', '$state', 'helpers', 'i18n', '$scope', 'campaignCategory',];

    function CampaignsAddController(debug, $stateParams, API, $state, helpers, i18n, $scope, campaignCategory) {
        var vm = this;
        vm.id = $stateParams.id;
        vm.isAdding = false;
        vm.add = add;

        vm.campaign = {
            active: 1,
            type: 'days',
            start_date: helpers.getDatabaseDatetime(),
            expires: '2100-01-01 00:00:00',
            category: '',
        };

        vm.loadingState = {
            subscriptionPlans: false,
        };

        vm.campaignMeta = {};

        vm.campaignCategories = {};
        vm.subscriptionPlans = [];

        vm.campaignCode = {
            active: 1,
            available_uses: -1,
        };

        vm.campaignType = '';

        vm.generateCode = generateCode;

        vm.campaignCodeGenerationType = 'one';

        activate();

        function activate() {
            angular.forEach(campaignCategory.get(), function(value, key) {
                value.then(function(response) {
                    vm.campaignCategories[key] = response;
                }, function() {});
            });
            if ($stateParams.type) {
                vm.campaignType = $stateParams.type;
                angular.extend(vm.campaign, {
                    type: 'days',
                    trial_extension_days: 21,
                });
                angular.extend(vm.campaignCode, {
                    available_uses: -1,
                });

                if (vm.campaignType === 'mini') {
                    vm.campaign.category = 'influenser-mini';
                }

                $scope.$watch('vm.campaign.name', function(newValue, oldValue) {
                    if (newValue && oldValue !== newValue) {
                        vm.campaignCode.code = vm.campaign.name.toLowerCase();
                        vm.campaignCode.code = vm.campaignCode.code.split(' ').join('-');
                    }
                });
            }

            loadSubscriptionPlans();
        }

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                vm.campaign.campaign_meta = JSON.stringify(vm.campaignMeta);

                var newCampaign = new API.Campaign(vm.campaign);

                var promise = newCampaign.$save();

                promise.then(function (newCampaignResponse) {
                    vm.isAdding = false;
                    if (vm.campaignCodeGenerationType === 'one') {
                        vm.campaignCode.fk_campaign_id = newCampaignResponse.id;
                        var newCampaignCode = new API.CampaignCode(vm.campaignCode);

                        var newCampaignCodePromise = newCampaignCode.$save();

                        newCampaignCodePromise.then(function() {
                            window.toast({ message: i18n.get('NEW_CAMPAIGN_CODE_SAVED'), type: 'success' });
                        }, function() {
                        })
                        .finally(function() {
                            $state.go('campaigns.edit', { id: newCampaignResponse.id });
                            vm.isAdding = false;
                        });
                    } else {
                        window.toast({ message: i18n.get('SAVED'), type: 'success' });
                        $state.go('campaigns.edit', { id: newCampaignResponse.id });
                    }

                }, function () {
                    vm.isAdding = false;
                });
            }
        }

        function loadSubscriptionPlans() {
            vm.loadingState.subscriptionPlans = true;
            API.SubscriptionPlan.search({ provider: 'Stripe' }).$promise.then(function (response) {
                angular.extend(vm.subscriptionPlans, response.items);

                vm.loadingState.subscriptionPlans = false;
            }, function () {});
        }

        function generateCode() {
            vm.campaignCode.code = helpers.generatePassword(15).toLowerCase();
        }
    }
})();